import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ReportsPartsActivityList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsPartsActivity/ReportsPartsActivityList/ReportsPartsActivityList"
    )
);
export const ReportsPartsActivity = () => {
  return (
    <Layout>
      <ReportsPartsActivityList />
    </Layout>
  );
};
